<script>
export default {
  data() {
    return {
      items: [
        {
          name: 'admin-pg-merchant-list',
          title: this.$t('pg_merchant_nav.list'),
        },
        {
          name: 'admin-pg-merchant-catalog',
          title: this.$t('pg_merchant_nav.information'),
        },
      ],
    }
  },
}
</script>

<template>
  <ul
    v-if="$route.name !== 'admin-pg-merchant-list'"
    :class="$style.localNavigation"
  >
    <router-link
      v-for="{ name, title } in items"
      :key="name"
      :to="{ name, params: $route.params }"
      :active-class="$style.on"
      tag="li"
    >
      <a href="#" @click.prevent>{{ title }}</a>
    </router-link>
  </ul>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
</style>
+
